import { formatOverloadValue, summarizeOverloadOptions } from '../domain/personalNikke.js';

export function PersonalNikkeOverload({ personal }) {
  if (!personal) return null;
  const effects = summarizeOverloadOptions(personal.equipment);
  if (!effects.length) return null;
  return (
    <span className="personal-nikke-overload" aria-label="오버로드 효과 합계">
      <span className="personal-nikke-overload-tooltip" role="tooltip">
        <strong>오버로드 효과 합계</strong>
        {effects.map((effect) => (
          <span key={`${effect.effectType}-${effect.valueType}`}>
            <span>{effect.label}<small>×{effect.count}</small></span>
            <b>{formatOverloadValue(effect)}</b>
          </span>
        ))}
      </span>
    </span>
  );
}
